import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Label, ListBox, Select } from '@heroui/react';
import { DatePickerField } from '@/components/datePickerField';
import { getNodeTestIdProp } from '@/utils';
import { ALL_SELLERS_KEY } from '../../shiftsMeta';
import type { ShiftRegisterFilters } from './useShiftRegister';

type ShiftRegisterFilterBarProps = ShiftRegisterFilters;

/** The register's day and seller filters (render-only). */
export const ShiftRegisterFilterBar: React.FC<ShiftRegisterFilterBarProps> = ({
    date,
    sellerId,
    sellers,
    onDateChange,
    onSellerChange,
}) => {
    const { t } = useTranslation('pages');

    return (
        <div
            className="flex flex-wrap items-end gap-3"
            {...getNodeTestIdProp('shift-register-filters')}
        >
            <div className="w-full max-w-60">
                <DatePickerField
                    id="shift-register-date"
                    label={t('shifts.dateLabel')}
                    name="shift-register-date"
                    onChange={onDateChange}
                    outputFormat="YYYY-MM-DD"
                    value={date}
                />
            </div>
            <Select
                className="w-full max-w-60"
                onChange={(key) =>
                    onSellerChange(key === null ? null : String(key))
                }
                value={sellerId ?? ALL_SELLERS_KEY}
                {...getNodeTestIdProp('shift-register-seller')}
            >
                <Label>{t('shifts.sellerLabel')}</Label>
                <Select.Trigger>
                    <Select.Value />
                    <Select.Indicator />
                </Select.Trigger>
                <Select.Popover>
                    <ListBox>
                        <ListBox.Item
                            id={ALL_SELLERS_KEY}
                            textValue={t('shifts.allSellers')}
                        >
                            {t('shifts.allSellers')}
                            <ListBox.ItemIndicator />
                        </ListBox.Item>
                        {sellers.map((seller) => (
                            <ListBox.Item
                                id={seller.id}
                                key={seller.id}
                                textValue={seller.name}
                            >
                                {seller.name}
                                <ListBox.ItemIndicator />
                            </ListBox.Item>
                        ))}
                    </ListBox>
                </Select.Popover>
            </Select>
        </div>
    );
};
